import { SelectableCard } from './SelectableCard';
import { StepHeading, StepHelperText } from './StepText';

interface Step5BudgetProps {
    title: string;
    helperText: string;
    options: string[];
    value: string | null;
    onSelect: (title: string) => void;
}

export const Step5Budget = ({
    title,
    helperText,
    options,
    value,
    onSelect,
}: Step5BudgetProps) => {
    return (
        <div className="flex flex-col gap-[1.375rem]">
            <StepHeading>{title}</StepHeading>
            <StepHelperText>{helperText}</StepHelperText>
            <ul className="flex flex-col gap-2">
                {options.map((option) => (
                    <li key={option}>
                        <SelectableCard
                            title={option}
                            selected={value === option}
                            onClick={() => onSelect(option)}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
